import React from 'react';
import { motion } from "framer-motion";
import { AlertCircle, Clock, GitBranch, Eye } from "lucide-react";

const problems = [
  { icon: AlertCircle, text: "Leads are missed or ignored" },
  { icon: Clock, text: "Follow-ups are inconsistent" },
  { icon: GitBranch, text: "No structured system to convert interest into bookings" },
  { icon: Eye, text: "No visibility into what actually drives revenue" },
];

export const PointOfView = () => {
  return (
    <section className="py-20 px-4 bg-background">
      <div className="max-w-4xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-3xl md:text-4xl font-bold mb-6 text-foreground"
        >
          Why Most Marketing Doesn't Work
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="text-lg text-muted-foreground mb-10 leading-relaxed"
        >
          Businesses don't have a lead problem—they have a conversion problem.
          Leads come in, but they're not followed up fast enough, not qualified properly, and not converted into customers.
        </motion.p>
        <div className="grid sm:grid-cols-2 gap-4">
          {problems.map((item, i) => (
            <motion.div
              key={item.text}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="flex items-start gap-3 p-4 rounded-lg bg-muted/50 border border-border"
            >
              <item.icon className="h-5 w-5 text-destructive mt-0.5 shrink-0" />
              <span className="text-foreground font-medium">{item.text}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
